import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

export interface ToastAction {
	text: string;
	handler: () => void | Promise<void>;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
	constructor(private toastCtrl: ToastController) {}

	async showToast(message: string, action?: ToastAction) {
		const toast = await this.toastCtrl.create({
			message: message,
			duration: action ? 3000 : 1500,
			position: 'bottom',
			buttons: action
				? [
						{
							text: action.text,
							role: 'info',
							handler: action.handler,
						},
					]
				: [],
		});
		toast.present();
	}

	async showToastOnError(message: string) {
		const toast = await this.toastCtrl.create({
			message: message,
			duration: 1500,
			position: 'bottom',
			color: 'danger',
		});
		toast.present();
	}

	async showToastOnSuccess(message: string) {
		const toast = await this.toastCtrl.create({
			message: message,
			duration: 1500,
			position: 'bottom',
			color: 'success',
		});
		toast.present();
	}
}
